import { InviteLock } from "@/components/growth/InviteLock";
import { Navigate, useParams } from "react-router-dom";
import { GameArena, ArenaHeader } from "@/components/games/GameArena";
import { DailyQuiz } from "@/components/ai/DailyQuiz";
import { ScratchSection } from "@/components/games/Scratch";
import { DuelsSection } from "@/components/games/Duels";
import { DuelLeaderboard } from "@/components/games/DuelLeaderboard";
import { TreasureCard, TreasureLeaderboard } from "@/components/Treasure";
import { useGames, gameOn, gameBlocked } from "@/lib/games";
import { BlockedNote } from "@/components/GameGate";
import { MegaHeartCard } from "@/components/MegaHeartCard";
import { AllInSection } from "@/components/games/AllInGifts";
import { ThanksWall } from "@/components/games/ThanksWall";
import { MysteryBoxFeedCard, MysteryPromoFeedCard } from "@/components/MysteryBox";
import { useUi, isHidden } from "@/lib/uiConfig";
import { WheelCatchUp } from "@/components/games/WheelCatchUp";
import { MemoryGame } from "@/components/skill/MemoryGame";
import { ReactionGame } from "@/components/skill/ReactionGame";
import { PuzzleGame } from "@/components/skill/PuzzleGame";
import { VaultGame } from "@/components/vault/VaultGame";

// slug -> [title, visibility id, game key (optional), content]
export const GAME_PAGES = {
  tresor: ["Goldener Tresor", "vault", "vault", () => <VaultGame />],
  gluecksrad: ["Glücksrad", "tile-wheel", "wheel", () => <WheelCatchUp />],
  "mega-herz": ["Mega-Herz", "megaheart", null, () => <MegaHeartCard />],
  geschenke: ["Geschenke verschicken", "allin", null, () => <><AllInSection /><ThanksWall /></>],
  "mystery-box": ["Mystery-Box", "mysterybox", null, () => <><MysteryBoxFeedCard /><MysteryPromoFeedCard /></>],
  quiz: ["Quiz des Tages", "quiz", null, () => <DailyQuiz />],
  schatzsuche: ["Schatzsuche", "treasure", "treasure", () => <><TreasureCard /><TreasureLeaderboard /></>],
  rubbellose: ["Rubbellose", "scratch", "scratch", () => <ScratchSection />],
  duelle: ["Freundes-Duelle", "duels", "duels", () => <><DuelsSection /><DuelLeaderboard /></>],
  memory: ["Memory", "skill-memory", null, () => <MemoryGame />],
  reaktion: ["Reaktions-Challenge", "skill-reaction", null, () => <ReactionGame />],
  puzzle: ["Tages-Puzzle", "skill-puzzle", null, () => <PuzzleGame />],
};

export default function GameDetail() {
  const { slug } = useParams();
  const cfg = useGames();
  const ui = useUi();
  const page = GAME_PAGES[slug];
  if (!page || isHidden(ui, page[1]) || (page[2] && cfg && !gameOn(cfg, page[2]))) return <Navigate to="/spiele" replace />;
  const [title, , game, Content] = page;
  return (
    <GameArena>
    <div className="max-w-2xl mx-auto space-y-5 pb-20" data-testid={`game-detail-${slug}`}>
      <ArenaHeader title={title} back="/spiele" />
      <InviteLock gate={["gluecksrad", "rubbellose"].includes(slug) ? "luck" : "games"} />
      <div className="fade-rise">{game && gameBlocked(cfg, game) ? <BlockedNote game={game} /> : <Content />}</div>
    </div>
    </GameArena>
  );
}
